module.exports = __webpack_public_path__ + "static/img/img_noright.cbb1aa84.png";